<template>

    <div @mousedown="mouseDown" @mouseup="mouseUp" @mousemove="mouseMove">

        <navigation ref="navigation"/>

        <main>
            <main-header>
                <div :class="['account', hasMultipleAccounts() ? 'multiple' : '']">
                    <icon name="arrow-down" v-if="hasMultipleAccounts()" />
                    {{ current.account.name }}
                    <select v-model="selected" @change="updateAccount" v-if="hasMultipleAccounts()">
                        <option v-for="account in current.accounts" :value="account.id">{{ account.name }}</option>
                    </select>
                </div>

                <div class="actions">

                    <router-link v-if="viewport == 'd'" :to="$onduro.route('profile')">
                        {{ current.user.name }}
                    </router-link>

                    <a class="help" @click="showHelp()" v-if="!current.user.demo">{{ $t('text.help') }}</a>

                    <a href="#" @click="toggleUniversity" v-if="hasUniversity" :class="['box-university', $store.state.current.account.demo ? 'btn btn--orange' : '']">University</a>

                    <router-link class="btn logout" :to="$onduro.route('logout')">
                        <icon name="logout" v-if="viewport == 'mp' || viewport == 'ml'" />
                        <span v-else>Logout</span>
                    </router-link>
                </div>
            </main-header>

            <router-view/>
        </main>
    </div>

</template>

<script>
import { mapState } from 'vuex';
import MainHeader from '../components/global/MainHeader';
import Navigation from '../components/modules/Navigation';
import events from '../events/events';

export default
{
    name: 'Backend',

    data()
    {
        return {
            selected: null,
        }
    },

    computed:
    {
        hasUniversity()
        {
            return this.current.locale == 'nl';
        },

         ...mapState({
            viewport: ({ layout }) => layout.viewport,
            current: ({ current }) => current,
            account: ({ current }) => current.account.id,
        }),
    },

    created()
    {
        this.selected = this.current.account.id;
        this.$store.dispatch('layout/setMainContentHeight');
    },

    updated: _.debounce(function () // Prevent update called twice
    {
        this.$store.dispatch('layout/setMainContentHeight')
    }, 150),

    watch:
    {
        account(val)
        {
            this.selected = val;
        }
    },

    methods:
    {
        updateAccount()
        {
            this.$http.put(`/api/switch/account/${this.selected}`,
            {
                mobile: location.hostname.match('mobile') ? true : false
            })
            .then(response =>
            {
                window.location.reload(true);
            });
        },

        toggleUniversity()
        {
            this.$university.toggle();
        },

        showUniversity()
        {
            this.$modal.close();
            this.$university.toggle();
        },

        hasMultipleAccounts()
        {
            return this.current.accounts.length > 1;
        },

        mouseDown($event)
        {
            this.$store.dispatch('app/mouseDown', true);
            events.$emit('mouse.down');
        },

        mouseUp($event)
        {
            this.$store.dispatch('app/mouseDown', false);
            events.$emit('mouse.up');
        },

        mouseMove($event)
        {
            if (this.$store.state.app.mouseDown)
            {
                events.$emit('mouse.drag', $event);
            }
        },

        showHelp()
        {
            let html = this.$t('widget.help.line1');

            if (this.hasUniversity)
            {
                html += this.$t('widget.help.line2');
            }

            html += this.$t('widget.help.line3');

            if (this.$current.profile == 'Ryanair')
            {
                html = '<b>Do you have any questions in regards to your contract or you would like to change your data?</b> Please raise a <u>Zendesk inquiry</u> to the Human Resources Department at Malta Air.';
            }

            if (this.$current.profile == 'Fiveguys')
            {
                html = '<b>Do you have any questions in regards to your contract or you would like to raise directly with Five Guys</b>? Please contact your manager or the human resources department at Five Guys.<br><br>Do you have questions <u>in regards to your profile data or salary payments</u>, please <a href="mailto:fiveguys@onduro.com">click here</a> to get in touch with the salary department.<br><br>For any <u>technical questions</u> please reach out to us by <a href="mailto:support@onduro.com">clicking here</a>.';
            }

            if (this.$current.profile == 'Pier14')
            {
                html = '<b>Do you have any questions in regards to your contract or you would like to raise directly with Pier 14</b>? Please contact your manager or the human resources department at Pier 14.<br><br>Do you have questions <u>in regards to your profile data or salary payments</u>, please <a href="mailto:pier14@onduro.com">click here</a> to get in touch with the salary department.<br><br>For any <u>technical questions</u> please reach out to us by support@onduro.com.';
            }

            this.$modal.show(this.$t('text.help'), html);

            this.$nextTick(() =>
            {
                let link = document.querySelector('.toggle-university');
                if (link) link.addEventListener('click', this.showUniversity);
            });
        }
    },

    components:
    {
        MainHeader,
        Navigation,
    },
}
</script>



// WEBPACK FOOTER //
// Backend.vue?e8b5e83e